import { render, staticRenderFns } from "./DirectDebits.vue?vue&type=template&id=d85c1ca6&"
import script from "./DirectDebits.vue?vue&type=script&lang=js&"
export * from "./DirectDebits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DirectDebits.vue"
export default component.exports